<template>
  <v-container>
    <div v-if="loading" class="text-center">
      <v-progress-circular indeterminate color="primary" />
    </div>

    <div v-else>
      <router-view :testator="testator" />
    </div>
  </v-container>
</template>

<script>
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';

  export default {
    name: 'RemainderOfEstateBase',
    data() {
      return {
        testator: {},
        loading: true,
      };
    },
    apollo: {
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        result(response) {
          if (response.data) this.loading = false;
        },
      },
    },
  };
</script>
